import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';

// content container inside of card
export default styled(Stack)({
  width: '100%',
  alignItems: 'center',
});
